var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.625,18H3.375a3.375,3.375,0,1,0,0,6.75h29.25a3.375,3.375,0,0,0,0-6.75Zm1.125,9H2.25a1.125,1.125,0,0,0-1.125,1.125V29.25a4.5,4.5,0,0,0,4.5,4.5h24.75a4.5,4.5,0,0,0,4.5-4.5V28.125A1.125,1.125,0,0,0,33.75,27ZM4.123,15.75H31.877c2.431,0,3.84-3.087,2.448-5.335C31.5,5.85,25.281,2.257,18,2.25S4.5,5.85,1.675,10.414C.281,12.663,1.692,15.75,4.123,15.75ZM27,7.875A1.125,1.125,0,1,1,25.875,9,1.125,1.125,0,0,1,27,7.875Zm-9-2.25A1.125,1.125,0,1,1,16.875,6.75,1.125,1.125,0,0,1,18,5.625ZM9,7.875A1.125,1.125,0,1,1,7.875,9,1.125,1.125,0,0,1,9,7.875Z","transform":"translate(0 -2.25)"}));
}

Burger.defaultProps = {"width":"36","height":"31.5","viewBox":"0 0 36 31.5"};

module.exports = Burger;

Burger.default = Burger;
